(() => {
  const TARGET = '#2F3B27';

  const isCartContext = (el) => !!el.closest(
    'cart-drawer, .cart-drawer, .drawer--cart, [data-cart-drawer], [data-cart-drawer-content], [class*="cart-drawer"], [id*="CartDrawer"]'
  );

  const isLikelyButton = (el) => {
    if (!(el instanceof HTMLElement)) return false;
    return el.matches(
      'button, a.button, .button, [role="button"], input[type="submit"], input[type="button"]'
    );
  };

  const paint = (el) => {
    if (!isLikelyButton(el)) return;
    if (!isCartContext(el) && !document.body.classList.contains('template-product')) return;

    const style = getComputedStyle(el);
    const bg = style.backgroundColor || '';

    const rgb = bg.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    const dark = rgb
      ? Number(rgb[1]) <= 55 && Number(rgb[2]) <= 55 && Number(rgb[3]) <= 55
      : false;

    const text = (el.textContent || '').trim().toLowerCase();
    const explicitCartCta = /continue shopping|checkout|view cart|add to bag|add to cart/.test(text);

    if (dark || explicitCartCta || isCartContext(el)) {
      el.style.setProperty('background-color', TARGET, 'important');
      el.style.setProperty('border-color', TARGET, 'important');
      el.style.setProperty('background-image', 'none', 'important');
      el.dataset.eliznaBotanicalGreen = '1';
    }
  };

  const scan = (scope = document) => {
    scope.querySelectorAll(
      'button, a.button, .button, [role="button"], input[type="submit"], input[type="button"]'
    ).forEach(paint);
  };

  const init = () => {
    scan();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (isLikelyButton(node)) paint(node);
          scan(node);
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
